import React, { useContext, useEffect, useState } from 'react'
import { Container, ContainerOutlet, ContentWrapper } from './style'
import UserContext from '../../contexts/UserContext'
import jwtDecode, { JwtPayload } from 'jwt-decode'
import ModalContext from '../../contexts/ModalContext'
import BaseModal from '../../components/Modal'
import FeedbackComponent from '../../components/FeedbackComponent'
import { FeedbackContext } from '../../contexts/FeedbackContext'
import { Outlet } from 'react-router-dom'
import HeaderComponent from '../../components/Header'
import ChatSidebar from '../../components/ChatSidebar'
import { NotificationProvider } from '../../contexts/NotificationContext'
import TableFiltersContext from '../../contexts/TableFiltersContext'
import { TableExportProvider } from '../../components/StandardPage/TableExportContext'
import { useSearch } from '../../contexts/SearchContext'

interface DecodedUser extends JwtPayload {
  email: string
  name: string
}

export interface TypeMainOutlet {
  search: string
  setSearch: React.Dispatch<React.SetStateAction<string>>
  clearSearch?: () => void
}

const ClientPanel = () => {
  const { user } = useContext(UserContext)
  const { modalActive } = useContext(ModalContext)
  const { feedback } = useContext(FeedbackContext)
  const { setGlobalFilter } = useContext(TableFiltersContext)
  const { search, setSearch, clearSearch } = useSearch()

  useEffect(() => {
    setGlobalFilter(search)
  }, [search, setGlobalFilter])

  const [isValidating, setIsValidating] = useState(true)
  const [isChatOpen, setIsChatOpen] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsValidating(false)
    }, 200)
    
    return () => clearTimeout(timer)
  }, [])

  if (isValidating) {
    return null
  }

  if (!user || (!user.id && !user.sub)) {
    return null
  }

  if (user.approved && user.approved !== 'approved') {
    if (user.approved === 'pending') {
      window.location.href = '/accessvalidation'
      return null
    } else if (user.approved === 'denied') {
      localStorage.removeItem('token')
      window.location.href = '/'
      return null
    }
  }
  
  return (
    <NotificationProvider>
      <TableExportProvider>
        <Container>
          <HeaderComponent
            search={search}
            setSearch={setSearch}
            isChatOpen={isChatOpen}
            onToggleChat={() => setIsChatOpen((v) => !v)}
          />
          {modalActive && <BaseModal />}
          {feedback.isOpen && <FeedbackComponent />}
          <ContentWrapper>
            <ContainerOutlet>
              <Outlet context={{ search, setSearch, clearSearch }} />
            </ContainerOutlet>
          </ContentWrapper>
          <ChatSidebar
            isOpen={isChatOpen}
            onClose={() => setIsChatOpen(false)}
          />
        </Container>
      </TableExportProvider>
    </NotificationProvider>
  )
}

export default ClientPanel
